import echo from '@/api/echo'

export default {
  data() {
    return {
      echoChannel: null
    }
  },
  watch: {
    orderToken(newValue) {
      if (newValue) {
        this.subscribeToOrderUpdatesOnSocket()
      } else {
        this.stopSubscribing()
      }
    }
  },
  mounted() {
    if (this.orderToken) {
      this.subscribeToOrderUpdatesOnSocket()
    }
  },
  beforeDestroy() {
    this.stopSubscribing()
  },
  methods: {
    subscribeToOrderUpdatesOnSocket() {
      this.echoChannel = `orders.${this.orderToken}`
      echo
        .channel(this.echoChannel)
        .listen('.order-lines.created', ({ order_line }) =>
          this.commitMutation('ADD_ITEMS', {
            orderLines: [order_line]
          })
        )
        .listen('.order-lines.deleted', ({ order_line_token }) =>
          this.commitMutation('REMOVE_ITEM', {
            orderLineToken: order_line_token
          })
        )
        .listen('.order-lines.updated', ({ order_line }) =>
          this.commitMutation('UPDATE_ITEM', {
            orderLine: order_line
          })
        )
        .listen('.table-bookings.arrived', event =>
          this.$store.dispatch('order/FETCH', this.orderToken)
        )
        .listen('.payments.created', () => this.$store.dispatch('order/FETCH', this.orderToken))
        .listen('.orders.prepared', () => this.$store.dispatch('order/FETCH', this.orderToken))
        .listen('.orders.locked', () => this.commitMutation('LOCK'))
        .listen('.orders.unlocked', () => this.commitMutation('UNLOCK'))
        .listen('.orders.ready', ({ customer_token: customerToken }) =>
          this.commitMutation('MARK_READY', { customerToken })
        )
        .listen('.orders.unready', ({ customer_token: customerToken }) =>
          this.commitMutation('MARK_NOT_READY', { customerToken })
        )
    },
    stopSubscribing() {
      if (this.echoChannel) {
        echo.leave(this.echoChannel)
      }
    },
    commitMutation(mutation, payload) {
      if (!payload) {
        this.$store.commit(`order/${mutation}`, this.orderToken)
      } else {
        this.$store.commit(`order/${mutation}`, {
          orderToken: this.orderToken,
          ...payload
        })
      }
    }
  }
}
